import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "all-body" }
const _hoisted_2 = { class: "content-body" }
const _hoisted_3 = { style: {"width":"200px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Topbar = _resolveComponent("Topbar")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_HolderOutlined = _resolveComponent("HolderOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Topbar),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_a_table, {
          dataSource: _ctx.sourceData,
          columns: _ctx.columns_info,
          pagination: _ctx.pageData,
          scroll: { x: 'max-content' }
        }, null, 8, ["dataSource", "columns", "pagination"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_table, {
          draggable: true,
          dataSource: _ctx.colDatas,
          columns: _ctx.col_info,
          pagination: false,
          size: "small"
        }, {
          bodyCell: _withCtx(({column, record}) => [
            (column.key === 'drag')
              ? (_openBlock(), _createBlock(_component_HolderOutlined, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns"])
      ])
    ])
  ]))
}